import { render, staticRenderFns } from "./BusinessUnitDetailsTableItem.vue?vue&type=template&id=e5ad8fe0&"
import script from "./BusinessUnitDetailsTableItem.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitDetailsTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports